<template >
<div @click="$emit('selectPr')" :style="type=='small'?'text-align:center':'text-align:center;width:200px;min-width: 50px;'">
    <!-- <img v-if="data.thumbnail" :src="data.thumbnail" :style="`width:${width}px;height:${height}px;`"> -->
    <img v-if="data.thumbnail" :src="data.thumbnail" :style="type=='small'?'height:50px;width:66px':'height:150px;min-height:50px;min-width:200px'">
    <h5 v-if="type=='big'" style="font-size:medium">{{ data.name }}</h5>
    <h5 v-else style="font-size:medium">{{ data.name }}</h5>
</div>
    
</template>
 <script>
 export default {
     name: 'BaseProduct',
     props: {
         data: Object,
         height: Number,
         width:Number,
         type:String
     },
     emits: ["selectPr"]
 }
 </script>
 <style scoped>
 </style>